import React from 'react';
import cn from 'classnames';
import CheckCell from './CheckCell';
import LinkCell from '@/finsight/ui/components/staticPages/Pricing/ComparePlansPanel/LinkCell';
import { UserPlanType } from '@/users/domain/UserPlan';

import styles from '../styles.scss';
import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';

interface IProps {
  cellData: boolean | string | React.ReactElement,
}

interface IDefaultProps {
  cellData: string,
  row: {
    url?: string,
    info?: string,
  },
}

const defaultColumns = [
  {
    name: 'featureName',
    title: 'Feature',
    stickyLeft: true,
    className: styles.featureCell,
    cellCallback: (props: IDefaultProps) => <LinkCell { ...props } />,
  },
];

const plansColumns = {
  [UserPlanType.STARTER]: {
    name: UserPlanType.STARTER,
    title: 'Starter',
    className: cn(alignStyles.alignCenter, styles.planCell),
    cellCallback: (props: IProps) => <CheckCell { ...props } />,
  },
  [UserPlanType.PREMIUM]: {
    name: UserPlanType.PREMIUM,
    title: 'Premium',
    className: cn(alignStyles.alignCenter, styles.planCell),
    cellCallback: (props: IProps) => <CheckCell { ...props } />,
  },
  [UserPlanType.PRO]: {
    name: UserPlanType.PRO,
    title: 'Professional',
    className: cn(alignStyles.alignCenter, styles.planCell),
    cellCallback: (props: IProps) => <CheckCell { ...props } />,
  },
};

export default (selectedPlan: UserPlanType) => {
  if (!selectedPlan) {
    return [...defaultColumns, ...Object.values(plansColumns)];
  }

  return [...defaultColumns, plansColumns[selectedPlan]];
};
